export const SCHEDULE_VIEWING_LABEL = 'Schedule Viewing';
export const REQUEST_INFO_LABEL = 'Request Info';
export const SCHEDULE_VIEWING_SUCCESS_LABEL = 'Viewing booked';
export const REQUEST_INFO_SUCCESS_LABEL = 'Request sent';
